import { takeLatest, put, call } from 'redux-saga/effects';

import { listAnoPecuarioCadastro } from '../service';
import {
    TABLE_ANO_PECUARIO_CADASTRO,
    TABLE_ANO_PECUARIO_CADASTRO_PENDING,
    TABLE_ANO_PECUARIO_CADASTRO_SUCCESS,
    TABLE_ANO_PECUARIO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAnoPecuarioCadastro(action) {
  yield put({ type: TABLE_ANO_PECUARIO_CADASTRO_PENDING })

  try {
    const table = yield call(listAnoPecuarioCadastro, action.args)
    yield put({ type: TABLE_ANO_PECUARIO_CADASTRO_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_ANO_PECUARIO_CADASTRO_FAILURE })
  }
}

export default function* watchListAnoPecuarioCadastro() {
  yield takeLatest(TABLE_ANO_PECUARIO_CADASTRO, sagaListAnoPecuarioCadastro)
}